import * as assets from './assets.action';
import * as canvas from './canvas.action';
import * as editor from './editor.action';
import * as elements from './elements.action';
import * as metadata from './metadata.action';
import * as navigation from './navigation.action';
import * as page from './page.action';
import * as permission from './permission.action';
import * as text from './text.action';
import * as user from './user.action';

export default {
  assets,
  canvas,
  editor,
  elements,
  metadata,
  navigation,
  page,
  permission,
  text,
  user
};
